// @flow
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';


import * as selectors from '../../modules/selectors';
import * as actions from '../../modules/actions';

import {
	getLeagueRoundAliases,
	getLeagueFinalFullNames
} from '../../helpers/league';

import TwoColumnLayoutWithSidebarWidgets from "../../components/TwoColumnLayoutWithSidebarWidgets";
import JsonFetcher from '../../components/utils/JsonFetcher';
import withRoundsSelector from '../../components/utils/withRoundsSelector';
import RoundSelector from '../../components/RoundSelector';
import AdsContainer from '../../components/AdsContainer';
import Ad from '../../components/Ad';
import PageTitle from '../../components/PageTitle';
import Ladder from '../../components/Ladder';
import TopBar from '../../components/TopBar';
import WaiverOrderWidget from '../../components/WaiverOrderWidget';
import { isRoundActive, isRoundComplete } from '../../helpers/rounds';

type Props = {
	selected_league_id: number,
	ladder_teams_ordered: Array<Object>,
	ladder_teams_by_id: Object,
	fetchLeague: typeof actions.leagueDraft.showDraftLeague,
	fetchLadder: typeof actions.leagueDraft.ladderDraftLeague,
	is_pending_show: boolean,
	is_pending_ladder: boolean,
	user_id: number,
	rounds_ordered: Array<Object>,
	rounds_by_id: Object,
	selected_round_id: number,
	setSelectedRoundId: Function,
	league: Object,
}

type State = {
	rfa_order_widget_open: boolean,
}

class LeagueLadderPage extends React.Component<Props, State> {
	state = {
		rfa_order_widget_open: false,
	}

	constructor(props) {
		super(props);

		_.bindAll(this, ['onToggleWaiverOrderWidget']);
	}

	componentDidMount() {
		const { selected_round_id } = this.props;

		this.fetchLeague();

		if (selected_round_id) {
			this.fetchLadder();
		}
	}

	componentDidUpdate(prev_props) {
		const { selected_league_id, selected_round_id, setSelectedRoundId } = this.props;

		if (
			selected_league_id &&
			selected_league_id !== prev_props.selected_league_id
		) {
			this.fetchLeague();
			this.fetchLadder();
		}
		else if (
			selected_round_id !== prev_props.selected_round_id
		) {
			this.fetchLadder();
		}

		if (
			selected_league_id !== prev_props.selected_league_id
		) {
			setSelectedRoundId(this.league_selected_round);
		}
	}

	get league_rounds() {
		const {
			rounds_ordered,
			league
		} = this.props;

		if (rounds_ordered && league && league.start_round && league.end_round) {
			return rounds_ordered.filter(round =>
				(round.id >= league.start_round && round.id <= league.end_round) &&
				(
					round.id === league.start_round ||
					isRoundActive(round) ||
					isRoundComplete(round)
				)
			);
		}

		return rounds_ordered;
	}

	get league_selected_round() {
		const { selected_round_id, league } = this.props;

		if (selected_round_id && league && this.league_rounds.length) {
			const start_round = _.first(this.league_rounds).id;
			const end_round = _.last(this.league_rounds).id;

			if ( selected_round_id < start_round) {
				return start_round;
			}
			else if (selected_round_id > end_round) {
				return end_round;
			}

			return selected_round_id;
		}

		return  null;
	}

	get league_current_round_fixtures() {
		const { league, selected_round_id } = this.props;
		return selected_round_id ?
			_.get(league, `fixture.${selected_round_id}`, []): [];
	}

	get league_next_round_fixtures() {
		const { league, selected_round_id } = this.props;
		return selected_round_id ?
			_.get(league, `fixture.${selected_round_id + 1}`, []): [];
	}

	fetchLadder() {
		const { fetchLadder, selected_league_id, selected_round_id } = this.props;
		fetchLadder({
			league_id: selected_league_id,
			round: selected_round_id
		});
	}

	fetchLeague() {
		const { fetchLeague, selected_league_id } = this.props;
		fetchLeague({
			id: selected_league_id
		});
	}

	onToggleWaiverOrderWidget() {
		this.setState(state => ({
			rfa_order_widget_open: !state.rfa_order_widget_open
		}));
	}

	renderMainSection() {
		const {
			league,
			ladder_teams_ordered,
			ladder_teams_by_id,
			rounds_by_id,
			rounds_ordered,
			selected_round_id,
			user_id,
		} = this.props;

		ladder_teams_ordered
			.sort((a,b) => a.rank_selected_round - b.rank_selected_round);
		const title_round =  selected_round_id || '-';
		const title_league_name = league ? league.name : '-';
		const round_full_names = getLeagueFinalFullNames(league, rounds_ordered);
		const round_full_name = round_full_names[selected_round_id];

		 return (
			<div>
				<PageTitle>
					{round_full_name || `Round ${title_round}`} Ladder for {title_league_name}
				</PageTitle>

				<Ladder
					league={league}
					user_id={user_id}
					ladder_teams_ordered={ladder_teams_ordered}
					ladder_teams_by_id={ladder_teams_by_id}
					rounds_by_id={rounds_by_id}
					selected_round_id={selected_round_id}
					league_current_round_fixtures={this.league_current_round_fixtures}
					league_next_round_fixtures={this.league_next_round_fixtures}
				/>
			</div>
		 );
	}

	renderAside() {
		const { league } = this.props;

		 return (
			<div>
				{league && league.id ? (
					<WaiverOrderWidget
						league_id={league.id}
						onToggle={this.onToggleWaiverOrderWidget}
						widget_open={this.state.rfa_order_widget_open}
					/>
				) : null }
			</div>
		 );
	}

	render() {
		const { setSelectedRoundId, selected_round_id, league, rounds_ordered } = this.props;
		const { rfa_order_widget_open } = this.state;

		return (
			<React.Fragment>
				<JsonFetcher fetch={['rounds']} />
				<TopBar league={league} />
				<RoundSelector
					selected={selected_round_id}
					rounds={this.league_rounds}
					handleClick={setSelectedRoundId}
					round_aliases={getLeagueRoundAliases(league, rounds_ordered)}
				/>

				<AdsContainer>
					<Ad
						adUnit='myleagues/ladder'
						size='top'
					/>
				</AdsContainer>

				<TwoColumnLayoutWithSidebarWidgets sidebar_open={rfa_order_widget_open}>
					{this.renderMainSection()}
					{this.renderAside()}
				</TwoColumnLayoutWithSidebarWidgets>

				<AdsContainer>
					<Ad
						adUnit='myleagues/ladder'
						size='bottom'
					/>
				</AdsContainer>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state, props) => {
	const selected_league_id = props.match.params.league_id;
	return {
		selected_league_id,
		league: selectors.leagueDraft.getLeague(state, props),
		is_pending_show: selectors.leagueDraft.show.isPending(state),
		is_pending_ladder: selectors.leagueDraft.ladder.isPending(state),
		ladder_teams_by_id: selectors.leagueDraft.ladder.getById(state),
		ladder_teams_ordered: selectors.orderedLadderCalculated(state, props),
		user_id: selectors.getUser(state).id,
	};
};

const mapDispatchToProps = {
	fetchLeague: actions.leagueDraft.showDraftLeague,
	fetchLadder: actions.leagueDraft.ladderDraftLeague
};

export const LeagueLadder = connect(
	mapStateToProps,
	mapDispatchToProps
)(LeagueLadderPage);

export default withRoundsSelector(LeagueLadder);


// WEBPACK FOOTER //
// ./src/pages/league/LeagueLadder.js